import {useQuery} from '@tanstack/react-query'
import {useEntityMutation} from '@/hooks/useEntityMutation'
import {useServices} from '@/services/context'
import type {RoleAssignment, AssignRoleRequest} from '@/types/roles'

export const SERVICE_ACCOUNT_ROLES_KEY = 'service-account-roles'

export function useServiceAccountRoles(serviceAccountId: string | undefined) {
    const services = useServices()
    return useQuery<RoleAssignment[]>({
        queryKey: [SERVICE_ACCOUNT_ROLES_KEY, serviceAccountId],
        queryFn: () => services.serviceAccountRoles.list(serviceAccountId!),
        enabled: !!serviceAccountId,
    })
}

export function useAssignServiceAccountRole(serviceAccountId: string) {
    const services = useServices()
    return useEntityMutation<RoleAssignment, Error, AssignRoleRequest>({
        mutationFn: (req: AssignRoleRequest) => services.serviceAccountRoles.assign(serviceAccountId, req),
        invalidate: [
            [SERVICE_ACCOUNT_ROLES_KEY, serviceAccountId],
        ],
    })
}

export function useRemoveServiceAccountRole(serviceAccountId: string) {
    const services = useServices()
    return useEntityMutation<void, Error, string>({
        mutationFn: (roleId: string) => services.serviceAccountRoles.remove(serviceAccountId, roleId),
        invalidate: [
            [SERVICE_ACCOUNT_ROLES_KEY, serviceAccountId],
        ],
    })
}
